import {
  SET_SELECTED_COLOR,
  SET_SELECTED_COLOR_FILTERS,
} from './actionTypes';
import { Utils } from '../utils/urlUtils';

export const setSelectedColor = (selectedColor) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_COLOR,
    selectedColor,
  });
};

export const setSelectedColorFilter = (selectedColorFilters) => (dispatch, getState) => {
  const { products: { currentOmsId } } = getState();
  const { draftingTool: { designClassification } } = getState();

  const transformedFilters = designClassification === 'none' || !designClassification
    ? selectedColorFilters
    : selectedColorFilters.map((filter) => {
      const isObject = typeof filter === 'object' && filter !== null;
      const filterLabel = isObject ? filter.label : filter;
      const filterType = isObject ? filter.type : undefined;

      let cleanedLabel = filterLabel.replace(/&reg;/g, '').trim();

      if (filterLabel.toLowerCase().includes('laminate')) {
        if (designClassification === 'custom') {
          cleanedLabel = cleanedLabel.replace(/ Custom Laminate$/, '').replace(/ Laminate$/, '');
          cleanedLabel += ' Custom Laminate';
        } else if (designClassification === 'postform') {
          cleanedLabel = cleanedLabel.replace(/ Custom Laminate$/, '').replace(/ Laminate$/, '');
          cleanedLabel += '&reg; Laminate';
        }
      }

      return isObject ? { type: filterType, label: cleanedLabel } : cleanedLabel;
    });

  Utils.setFilters(transformedFilters, currentOmsId);

  dispatch({
    type: SET_SELECTED_COLOR_FILTERS,
    selectedColorFilters: transformedFilters,
  });
};
